<template>
  <section class="workspace-stack">
    <article class="glass-surface workspace-panel">
      <div class="workspace-panel__header">
        <div>
          <span class="workspace-kicker">Facturas manuales</span>
          <h2 class="workspace-title">Cobros manuales</h2>
          <p class="workspace-copy">Selecciona el metodo final, confirma el cobro y registralo desde este panel.</p>
        </div>
      </div>

      <div class="workspace-metrics">
        <article class="workspace-metric">
          <small>Facturas pendientes</small>
          <strong>{{ filteredEvents.length }}</strong>
        </article>
        <article class="workspace-metric">
          <small>Monto pendiente</small>
          <strong>${{ pendingTotal }}</strong>
        </article>
      </div>

      <div class="workspace-toolbar">
        <label class="workspace-search">
          <i class="fas fa-search"></i>
          <input v-model="search" type="text" placeholder="Buscar por nombre, correo o evento" />
        </label>
      </div>

      <div v-if="!filteredEvents.length" class="workspace-empty">No hay facturas manuales pendientes.</div>
      <div v-else class="workspace-table-shell">
        <table class="workspace-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Fecha</th>
              <th>Cliente</th>
              <th>Correo</th>
              <th>Evento</th>
              <th>Monto</th>
               <th>Metodo</th>
              <th>Accion</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="invoice in filteredEvents" :key="invoice.id">
              <td>{{ invoice.id }}</td>
              <td>{{ formatDate(invoice.date) }}</td>
              <td>{{ invoice.user }}</td>
              <td>{{ invoice.email }}</td>
              <td>{{ invoice.event }}</td>
              <td>${{ formatMoney(invoice.total) }}</td>
              <td>
                <select v-model.number="invoice.selected_payment_type" class="workspace-input workspace-select">
                  <option :value="0">Selecciona</option>
                  <option :value="3">Tarjeta credito</option>
                  <option :value="6">Tarjeta debito</option>
                  <option :value="4">PayPal</option>
                  <option :value="2">Transferencia</option>
                  <option :value="5">POS</option>
                  <option :value="1">Efectivo</option>
                  <option :value="7">Rechazar</option>
                </select>
              </td>
              <td>
                <button class="workspace-button workspace-button--primary workspace-button--small" type="button" @click="createPayment(invoice)">
                  <i class="fas fa-check"></i>
                  <span>Confirmar</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="workspace-actions workspace-actions--end">
        <spring-spinner v-if="loading" v-show="next" :size="48" color="#8cf3e8" />
        <button v-show="next && !loading" class="workspace-button" type="button" @click="getEvents">Cargar mas</button>
      </div>
    </article>
  </section>
</template>

<script>
import { apiService } from "../../common/api.services.js";
import { SpringSpinner } from 'epic-spinners';
import { apiServiceForm } from "../../common/api.services.js";


export default {
  name: "PendingPaymentList",
  data() {
    return {
      events: [],
      next: null,
      loadingTable: true,
      search: "",
      loading: false,
      promoter_table:[],
      is_staff:localStorage.getItem('is_staff'),
      payment_type:0,
      bank_fee: 0,
      revenue_fee: 0,
      payment_t:0,
      error: ''
    };
  },
  components: {
    SpringSpinner,
  },

  props: {
    event: {
      required: true,
    },
  },

  computed: {
    filteredEvents() {
      const term = this.search.trim().toLowerCase()
      if (!term) {
        return this.events
      }

      return this.events.filter((invoice) => {
        const haystack = `${invoice.user || ''} ${invoice.email || ''} ${invoice.event || ''}`.toLowerCase()
        return haystack.includes(term)
      })
    },

    pendingTotal() {
      const total = this.filteredEvents.reduce((sum, invoice) => sum + (Number.parseFloat(invoice.total) || 0), 0)
      return total.toFixed(2)
    },
  },

  created() {
    this.getEvents();
  },

  methods: {


    
    formatMoney(value) {
      const parsed = Number.parseFloat(value)
      return Number.isNaN(parsed) ? '0.00' : parsed.toFixed(2)
    },

    inferSelectedPaymentType(invoice) {
      const optionId = Number(invoice && invoice.payment_option ? invoice.payment_option : 0)
      const map = {
        1: 4,
        2: 2,
        3: 3,
        4: 2,
        5: 3,
        6: 3,
        7: 3,
        8: 2,
      }
      return map[optionId] || 0
    },

    resolveSelectedPaymentType(invoice) {
      return Number(invoice.selected_payment_type || this.inferSelectedPaymentType(invoice) || 0)
    },

    createPayment(invoice) {

const index = this.events.findIndex((item) => item.id === invoice.id)
if (index === -1) {
  return
}

const selectedPaymentType = this.resolveSelectedPaymentType(invoice)
invoice.selected_payment_type = selectedPaymentType
if (selectedPaymentType === 0) {
  this.error = 'Debes seleccionar el metodo final antes de confirmar.'
  return
}



let status_final = 1
this.loading=true
  let  endpoint =  `/api/manual-p/?tran_id=fomoaut`

  if (selectedPaymentType==1){
    this.bank_fee=0
    this.payment_t=1
  }else if(selectedPaymentType==2){
    this.bank_fee=0
    this.payment_t=2
  }else if(selectedPaymentType==3){
    this.payment_t=3
  let dataF=(parseFloat(this.events[index].total)*0.015)
   this.bank_fee= (parseFloat(this.events[index].total)*0.0448)+ dataF + (dataF*0.12)
  }else if(selectedPaymentType==4){
    this.bank_fee=(parseFloat(this.events[index].total)*0.054)+0.30
    this.payment_t=3


  }else if (selectedPaymentType==5){

    this.bank_fee= (parseFloat(this.events[index].total)*0.0448)
    this.payment_t=5



  }else if(selectedPaymentType==6){
   let  dataF=(parseFloat(this.events[index].total)*0.005)
   this.bank_fee= (parseFloat(this.events[index].total)*0.0225)+dataF + (dataF*0.12)
   this.payment_t=3
  
  }else if(selectedPaymentType==7){
   let  dataF=(parseFloat(this.events[index].total)*0.005)
   this.bank_fee= (parseFloat(this.events[index].total)*0.0225)+dataF + (dataF*0.12)
   this.payment_t=1
   status_final=4
  }


  const data = new FormData()
  
  data.append('amount', this.events[index].total)
  data.append('invoice', this.events[index].id)
  data.append('point_of_sale', this.events[index].pos)
  data.append('url', "")
  data.append('url_number', "")
  data.append('comment', "Ingreso Manual")
  data.append('subtotal', this.events[index].subtotal)
  data.append('fee', this.events[index].fee)
  
 
 
  if (selectedPaymentType==2){
  this.revenue_fee=this.events[index].fee
  }else{
    this.revenue_fee=parseFloat(this.events[index].fee)-parseFloat(this.bank_fee)
    this.revenue_fee=this.revenue_fee.toFixed(2)
  }


     this.bank_fee=parseFloat(this.bank_fee).toFixed(2)


     data.append('bank_fee', this.bank_fee)
     data.append('revenue_fee', this.revenue_fee)

  
  data.append('ticket',"")
  data.append('payment_selection', selectedPaymentType)
  data.append('payment_type',   this.payment_t)
  data.append('status', status_final)
  data.append('is_manual', 1)

  
  apiServiceForm(endpoint, "POST", data)
        .then(data => {
          this.loadingMain=false
          console.log("pago creado")
          console.log(data)
          this.events.splice(index, 1)






        }).catch(error => {

    alert("Error al ingresar el pago. Por favor comunícate con nosotros para revisar el caso.")
    console.log("error pago:")
    console.log(error)
    //alert('Ha ocurrido un ERROR al actualizar el perfil. Inténtelo nuevamente.  SUDEN - CURSOS CON BOLSA DE EMPLEO')
    //window.location.href = "https://www.somossuden.com/inicio/student-registration.html";


  })
  
 //Ver si el usuario tiene cursos adicionales...
// if (this.event.id==16){
//  this.print()

  
// }

 //Cambiar contraseña y estado del usuario a activado...


},




    changeStatus(index){
    this.success = false

    let id = this.events[index].id


    let endpoint =  `/api/payment/${id}/change?type=${this.events[index].status}`
    apiService(endpoint, "PUT")
              .then(data => {
                  if (data.id){
                    this.events.splice(index, 1)
                  }else{
                      //Especificar error
                      this.error=data.err
                  }

    
              })


    
    },





    formatDate(dateString){
              const date = new Date(dateString);
                // Then specify how you want your dates to be formatted

                console.log(date)
            return new Intl.DateTimeFormat('default', {dateStyle: 'short'}).format(date);
    },



    populateBar() {
      this.generatedBar = {
        labels: ["Tarjeta", "Transferencia", "Efectivo"],
        datasets: [
          {
            label: "$",
            backgroundColor: "blue",
            data: [this.card, this.bank, this.cash],
          },
        ],
      };
    },

    populateData() {
      let labelArr = [];
      let backgroundColorArr = [];
      let dataArr = [];

      for (let index = 0; index < this.eventTickets.length; index++) {
        console.log("paso");

        let lname =
          this.eventTickets[index].name + "-" + this.eventTickets[index].code;
        labelArr.push(lname);

        let maxVal = 0xffffff; // 16777215
        let randomNumber = Math.random() * maxVal;
        randomNumber = Math.floor(randomNumber);
        randomNumber = randomNumber.toString(16);
        let randColor = randomNumber.padStart(6, 0);
        let color = `#${randColor.toUpperCase()}`;
        backgroundColorArr.push(color);

        let value =
          this.eventTickets[index].initial_quantity -
          this.eventTickets[index].remaining_tickets;
        dataArr.push(value);

        let obj = Object();
        obj.section =
          this.eventTickets[index].name + "-" + this.eventTickets[index].code;
        obj.tickets = value;
        obj.remaining = this.eventTickets[index].remaining_tickets;
        this.total_tickets.push(obj);
      }
      this.loadingTable = false;
      console.log(labelArr);
      console.log(dataArr);
      console.log(backgroundColorArr);

      this.generatedData = {
        labels: labelArr,
        datasets: [
          {
            label: "Tickets x Sección",
            backgroundColor: backgroundColorArr,
            data: dataArr,
          },
        ],
      };
    },

    openEvent(_id) {
      this.$router.push({ name: "EventHostView", params: { slug: _id } });
    },

    searchEvents() {
      this.events = [];
      this.getEvents();
      this.next = null;
    },

    populateDataS(){

      

        let money_count=0
        let sale_count=0


        let array= this.events
        let code_n=array[0].product_code


      





        for (let index = 0; index < array.length; index++) {
          if (array[index].product_code==code_n){
          money_count=parseFloat(money_count)+parseFloat(array[index].amount)
          sale_count++;
         
        }else{
          let payment_obj = Object()
          payment_obj.money=money_count
          payment_obj.code=array[index].product_code
          payment_obj.count=sale_count


          this.promoter_table.push(payment_obj)
          money_count=0
          sale_count=0
          code_n=array[index].product_code
          console.log(code_n)

        }
        }
    },

    getEvents() {
      // make a GET Request to the questions list endpoint and populate the questions array

      //tipo 1 para generico y tipo 2 para mis cursos y usar el mismo componente
      let endpoint = "/api/invoices-data/?status=pending";
       

      if (this.next) {
        endpoint = this.next;
        this.loading=true
      }
      this.loadingQuestions = true;
      apiService(endpoint).then((data) => {
        const items = Array.isArray(data) ? data : (data && data.results ? data.results : [])
        this.events = this.events.concat(items.map((item) => ({ ...item, selected_payment_type: item.selected_payment_type || this.inferSelectedPaymentType(item) })));
        this.showLoading = false;
        this.loading=false
        if (data && data.next) {
          //si no es null
          this.next = data.next;
        } else {
          //Si no es null
          this.next = null;
        }
       // this.populateDataS()
      });

      
    
    
    },

  },
};
</script>

<style scoped>
.workspace-table-shell {
  overflow: auto;
}

.workspace-table {
  width: 100%;
  border-collapse: collapse;
}

.workspace-table th,
.workspace-table td {
  padding: 14px 12px;
  border-bottom: 1px solid rgba(223, 214, 255, 0.08);
  text-align: left;
  color: var(--text-soft);
}

.workspace-table th {
  color: var(--text-main);
  font-size: 0.75rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}
</style>
